import React,{useState,useEffect} from "react";
import EvaluationQuestions from "../../../components/evaluationQuestions";

import { message } from "antd";
import server, { endpoints } from '../../../utils/server';
import "./styles/evaluationsQuestions.css"
const EvaluationsQ = ({team,selectedT,selectedE,questionsLength, idUR, changeView,answerQuestions}) => {

      const [teams, setTeams] = useState();
      const [selectedTeam, setSelectedTeam] = useState();
      const [selectedEvaluation, setSelectedEvaluation] = useState();
      const [changeQuestion, setChangeQuestion] = useState(0);
      const [answerReady, setAnswerReady] = useState([]);
      const [answeredQuestions, setAnsweredQuestions] = useState([]);
      const [teamCounter, setTeamCounter] = useState(0);

      useEffect(() => {
        setTeams(team);
        setSelectedTeam(selectedT);
        setSelectedEvaluation(selectedE);
        setChangeQuestion(0);
      }, [selectedT,selectedE]);

      const onChangeEvaluationsAnswer = (answer, questionIndex) => {
        if (!selectedT || !selectedE) {
          return;
        }
        
        let teamsAux = [...teams];
        const teamIndex = teamsAux.findIndex(({ id_team }) => selectedTeam?.id_team === id_team,);
        let evaluationsAux = teams[teamIndex]?.evaluations;
        const evaluationIndex = evaluationsAux.findIndex(({ id }) => id === selectedEvaluation?.id);
        let evaluation = evaluationsAux[evaluationIndex];
        evaluation.questions[questionIndex].answer = answer; 
        evaluationsAux[evaluationIndex] = evaluation;
        teamsAux[teamIndex].evaluations = evaluationsAux;

        setAnswerReady(true);
        setSelectedEvaluation(evaluation);
        setTeams(teamsAux);
      }
    
      const onChangeUserReview = (answer, questionIndex, idUserReviewed) => {
    
        if (!selectedT || !selectedE) {
          return;
        }
        let teamsAux = [...teams];
        const teamIndex = teamsAux.findIndex(({ id_team }) => selectedTeam?.id_team === id_team);
        let evaluationsAux = teams[teamIndex]?.evaluations;
        const evaluationIndex = evaluationsAux.findIndex(({ id }) => id === selectedEvaluation?.id);
        let evaluation = evaluationsAux[evaluationIndex];
        let answersAux = [];
        
        if (!!evaluation.questions[questionIndex].answer) {
          answersAux = evaluation.questions[questionIndex].answer;
        }
        const answerIndex = answersAux.findIndex(({ id_user }) => id_user === idUserReviewed);
        if (answerIndex >= 0) {
          answersAux[answerIndex].answer = answer;

        } else {
          
          setTeamCounter(teamCounter+1);
          if(teamCounter==selectedTeam?.teamUsers.length-1){
            setAnswerReady(true);
            setTeamCounter(0);
            
            const auxArray=answeredQuestions;
            auxArray.push(true);
            setAnsweredQuestions(auxArray);
            
          }
          answersAux.push({
            id_user: idUserReviewed,
            answer,
          });
        }
        evaluation.questions[questionIndex].answer = answersAux;
        evaluationsAux[evaluationIndex] = evaluation;
        teamsAux[teamIndex].evaluations = evaluationsAux;

        setSelectedEvaluation(evaluation);
        setTeams(teamsAux);
      }

      

      const handleNextQuestion = () => {
        if(changeQuestion==selectedEvaluation.questions.length-1){
          if(answerReady==true || answeredQuestions[changeQuestion]==true){
          answerQuestions(teams,selectedTeam,selectedEvaluation)
          changeView(2);
          }else{
            message.error("Porfavor contesta la pregunta antes de continuar")
          }

        }else if(answerReady==true || answeredQuestions[changeQuestion]==true){
          const auxArray=answeredQuestions;
          if(answeredQuestions.length<=changeQuestion){
            auxArray.push(answerReady);
            setAnsweredQuestions(auxArray);
          }
          
          setAnswerReady(false);
          setChangeQuestion(changeQuestion+1);

        }else{
          message.error("Porfavor contesta la pregunta antes de continuar")
        }
        
      }

      const handleBackQuestion = () => {
        if(changeQuestion==0){
          answerQuestions(teams,selectedTeam,selectedEvaluation)
          changeView(0);
          
        }else if(changeQuestion>0 ){
          setChangeQuestion(changeQuestion-1);
        }
        
      }

    return(
        <>
            <div className="evaluationsQ-role-selector-container">

      <div>
      {selectedEvaluation?.questions?.map((t, index) => (
      <div key={`${selectedTeam?.id_team}-${selectedEvaluation?.id}-${t.id}`}>

        {index === changeQuestion && (
          <EvaluationQuestions
            t={t}
            idUR={idUR}
            teamUsers={selectedTeam?.teamUsers}
            onChangeEvaluationsAnswer={(answer) => onChangeEvaluationsAnswer(answer, index)}
            onChangeUserReview={(answer, idUserReviewed) => onChangeUserReview(answer, index, idUserReviewed)}
          />
        )}
      </div>
    ))}        
          </div>


      <div className="evaluationsQ-buttons-container">
        <button className="evaluationsQ-btn-next" onClick={()=>{handleNextQuestion() }} >Siguiente</button>
        <button className="evaluationsQ-btn-back" onClick={()=>{handleBackQuestion() }}>Regresar</button>
        <button className="evaluationsQ-btn-save" >Guardar</button>
      </div>
    </div>
        </>
    )
    }
export default EvaluationsQ;